import { Loader2, Inbox, TriangleAlert } from "lucide-react";

export const LoadingState = ({ label = "Loading…", onDark = false, testId = "loading-state" }) => (
  <div
    data-testid={testId}
    className={`flex flex-col items-center justify-center gap-3 py-16 ${
      onDark ? "text-white/70" : "text-navy/70"
    }`}
  >
    <Loader2 className="h-8 w-8 animate-spin text-orange" />
    <span className="text-sm">{label}</span>
  </div>
);

export const EmptyState = ({
  title = "Nothing here yet",
  description = "Content will appear here soon.",
  onDark = false,
  testId = "empty-state",
}) => (
  <div
    data-testid={testId}
    className={`flex flex-col items-center justify-center gap-3 rounded-2xl border border-dashed py-16 text-center ${
      onDark ? "border-white/15 text-white/70" : "border-navy/15 text-navy/70"
    }`}
  >
    <Inbox className="h-9 w-9 opacity-70" />
    <h3 className={`font-heading text-xl ${onDark ? "text-white" : "text-navy"}`}>{title}</h3>
    <p className="max-w-sm text-sm">{description}</p>
  </div>
);

export const ErrorMessage = ({
  title = "Something went wrong",
  description = "Please try again in a moment.",
  onDark = false,
  testId = "error-message",
}) => (
  <div
    data-testid={testId}
    role="alert"
    className={`flex items-start gap-3 rounded-xl border p-4 ${
      onDark ? "border-destructive/40 bg-destructive/10 text-white" : "border-destructive/30 bg-destructive/5 text-navy"
    }`}
  >
    <TriangleAlert className="mt-0.5 h-5 w-5 shrink-0 text-destructive" />
    <div className="flex flex-col">
      <span className="text-sm font-semibold">{title}</span>
      <span className="text-sm opacity-80">{description}</span>
    </div>
  </div>
);
